module.exports = __webpack_public_path__ + "media/images/nosotros-0f8f88875c67d3859ff95fc8b5c7ae96.jpg";